import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import drEasyApi from "../../../Api/Customapi";
import { useLanguage } from "../../../context/LanguageContext";

const ChangePassword = ({ slug, token }) => {
  const { t } = useLanguage();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const res = await drEasyApi.put(
        `/api/${slug}/User/ChangePassword`,
        {
          currentPassword: values.currentPassword,
          newPassword: values.newPassword,
          confirmPassword: values.confirmPassword,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data?.isSuccessStatusCode || res.status === 200) {
        message.success(t("settings.changePassword.success"));
        form.resetFields();
      } else {
        message.error(res.data?.message || t("settings.changePassword.error"));
      }
    } catch (error) {
      console.error(error);
      if (error.response?.data?.[0]?.includes("Incorrect password")) {
        message.warning(t("settings.changePassword.incorrectPassword"));
      } else {
        message.error(error.response?.data?.[0] || t("settings.changePassword.error"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto mt-12 bg-white p-6 shadow rounded-lg">
      <h2 className="text-xl font-bold mb-4 text-primary">
        {t("settings.changePassword.title")}
      </h2>

      <Form form={form} layout="vertical" onFinish={handleSubmit} size="large">
        {/* Current Password */}
        <Form.Item
          name="currentPassword"
          label={
            <span className="text-sm font-medium">
              {t("settings.changePassword.currentPassword")}
            </span>
          }
          rules={[
            {
              required: true,
              message: t("settings.changePassword.currentPasswordRequired") || "Current password is required",
            },
          ]}
        >
          <Input.Password placeholder={t("settings.changePassword.currentPassword")} className="w-full border rounded" />
        </Form.Item>

        {/* New Password */}
        <Form.Item
          name="newPassword"
          label={
            <span className="text-sm font-medium">
              {t("settings.changePassword.newPassword")}
              
            </span>
          }
          rules={[
            {
              required: true,
              message: t("settings.changePassword.newPasswordRequired") || "New password is required",
            },
            {
              min: 6,
              message: t("settings.changePassword.minLength") || "Password must be at least 6 characters",
            },
            {
              pattern: /^(?=.*[A-Z]*[a-z])(?=.*\d)[A-Za-z\d@$!%*#?&.]{6,}$/,
              message: t("auth.passwordPattern") || "Password must contain letters and numbers",
            }
          ]}
        >
          <Input.Password placeholder={t("settings.changePassword.newPassword")} className="w-full border rounded" />
        </Form.Item>

        {/* Confirm Password */}
        <Form.Item
          name="confirmPassword"
          label={
            <span className="text-sm font-medium">
              {t("settings.changePassword.confirmPassword")}
            </span>
          }
          dependencies={["newPassword"]}
          rules={[
            {
              required: true,
              message: t("settings.changePassword.confirmPasswordRequired") || "Please confirm your password",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value)
                  return Promise.resolve();
                return Promise.reject(
                  new Error(
                    t("settings.changePassword.passwordMismatch") ||
                      "Passwords do not match"
                  )
                );
              },
            }),
          ]}
        >
          <Input.Password placeholder={t("settings.changePassword.confirmPassword")} className="w-full border rounded" />
        </Form.Item>

        <Form.Item>
          <Button
            htmlType="submit"
            loading={loading}
            className="w-full bg-primary text-white py-2 rounded border-none disabled:opacity-50"
          >
            {loading
              ? t("settings.changePassword.changing")
              : t("settings.changePassword.changeButton")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ChangePassword;